export enum EVENT_CODES {
  PAYMENT_MODAL = 2000, // For invoking payment modal
}
